import { Link } from "react-router-dom";
import { LogoGlyph } from "@/components/Logo";

/**
 * Sitewide compact footer. Legal links + generic PostShifted marks. Rendered
 * inside each page just below the main content.
 */
export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-16 border-t border-neutral-200 bg-white" data-testid="site-footer">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 py-8 md:flex-row md:items-center md:justify-between lg:px-10">
        <div className="flex items-center gap-2">
          <LogoGlyph size={16} />
          <span className="font-serif text-sm font-semibold text-neutral-900">
            PostShifted<span className="text-coral">.</span>
          </span>
          <span className="ml-2 text-xs text-neutral-500">© {year}</span>
        </div>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-neutral-500">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-neutral-900"
          >
            Terms of Service
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-neutral-900"
          >
            Privacy Policy
          </Link>
          <Link
            to="/refund"
            data-testid="footer-refund-link"
            className="hover:text-neutral-900"
          >
            Refund Policy
          </Link>
          <Link
            to="/pricing"
            data-testid="footer-pricing-link"
            className="hover:text-neutral-900"
          >
            Pricing
          </Link>
          <Link
            to="/contact"
            data-testid="footer-contact-link"
            className="hover:text-neutral-900"
          >
            Contact
          </Link>
        </nav>
      </div>
    </footer>
  );
}
